module.exports = __webpack_public_path__ + "static/media/b_icon_01.bf7a89d6.png";